import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../../components/ErpTemplate';
import { FaCheck, FaExclamationTriangle } from 'react-icons/fa';
import api from '../../../services/api';
import { useHistory, useLocation } from 'react-router-dom';
import { extract } from '../../../util/util';
import { toast } from 'react-toastify';
import MostrarHTML from '../../../components/MostrarHtml';
import { getText, getIdiomaCodigo } from '../../../util/translations';
import { getAuthPerfil, getAuthToken } from '../../../util/authSession';
import { rotaDoStep, irParaProximoStep } from '../../../util/fluxoConvite';
import '../../../css/financeiro-parcela-pagar.css';

export default function CadastroEventoParticipanteCartaInformativa({ match }) {
    const id = match.params.id;
    const token = getAuthToken();
    const perfil = getAuthPerfil();
    const contrato = new URLSearchParams(window.location.search).get('contrato');
    const [data, setData] = useState(null);
    const [concordaConvite, setConcordaConvite] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    // Modelo da carta barrado pela trava do evento: troca o card vazio por um aviso traduzido.
    const [cartaIndisponivel, setCartaIndisponivel] = useState(false);
    const history = useHistory();
    const { state } = useLocation();
    const idioma = getIdiomaCodigo();

    const buscar = () => {
        setIsLoading(true);
        setIsError(false);
        setCartaIndisponivel(false);
        api({
            method: "get",
            action: '/participante/' + id,
            token: token,
        }).then(response => {
            //extrai dados internos para o array principal
            var dadosRecebidos = extract({
                jsonLaravel: response.data.data,
                chaves: [
                    'enderecopais',
                    'aereomunicipioembarque',
                    'enderecomunicipio',
                    'banco',
                ]
            });

            //o back decide a etapa (proximoStep). Se esta tela ('cartaInformativa') não é a atual, redireciona.
            if (dadosRecebidos.proximoStep !== 'cartaInformativa') {
                history.push(rotaDoStep(dadosRecebidos.proximoStep, { id, eventoId: dadosRecebidos.evento.id, contrato }));
                return;
            }

            api({
                method: "get",
                action: '/eventoCarta/visualizarCartaHtml/' + id,
                token: token,
                params: {
                    tipoCarta: "modelocarta",
                }
            }).then(response => {
                setData({
                    ...dadosRecebidos,
                    ...{ htmlCarta: response.data.data.htmlCarta }
                });
                setIsLoading(false);
            }).catch(function (error) {
                // A trava de seguranca do evento barrou o modelo desta carta: a API responde com
                // `code: carta_indisponivel`. Aviso fixo e traduzido dentro do card — o toast
                // generico fechava em 3,5 s e deixava o convidado diante de um card vazio, sem
                // saber que precisa falar com a organizacao do evento.
                if (error?.response?.data?.code === 'carta_indisponivel') {
                    setCartaIndisponivel(true);
                } else {
                    toast.error(`${getText('error')} ${getText('errorLoadingDefault')}`);
                }
                setIsLoading(false);
                setIsError(true);
            });
        }).catch(err => {
            setIsLoading(false);
            setIsError(true);
            toast.error(`${getText('error')} ${getText('errorLoadingDefault')}`);
        });
    };//buscar

    const continuar = () => {
        // Marca a carta informativa como confirmada (dataconfirmacaocartainformativa) e segue.
        // Sem o carimbo, o step 'cartaInformativa' voltaria em loop.
        setIsLoading(true);
        api({ method: 'put', action: '/participante/' + id + '/confirmarCartaInformativa', token: token })
            .then(() => {
                irParaProximoStep(history, { id, token, eventoId: data?.evento?.id, contrato, setLoading: setIsLoading });
            })
            .catch(() => {
                setIsLoading(false);
                toast.error(getText('error') + getText('errorRefreshPage'));
            });
    }; //continuar

    useEffect(() => { //onload
        buscar();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate sidebar={['listarsvp', 'cliente'].includes(perfil) ? false : true} processando={isLoading} idioma={idioma ?? "both"}>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div><h1 className="fin-pp__title">{getText('cartaInformativa')}</h1></div>
                </div>

                <div className="fin-pp__card" style={{ padding: 24, marginBottom: 16 }}>
                    {cartaIndisponivel && (
                        <div className="fin-pp__banner is-warn">
                            <FaExclamationTriangle size={16} className="fin-pp__banner-ic" />
                            <span>{getText('cartaIndisponivel')}</span>
                        </div>
                    )}
                    <MostrarHTML
                        htmlContent={data?.htmlCarta ?? null}
                    />
                    {!isLoading && !isError && data?.evento && (
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
                            <button
                                type="button"
                                className="fin-pp__btn fin-pp__btn--primary"
                                onClick={continuar}
                            >
                                <FaCheck size={16} style={{ marginRight: 6 }} /> {getText('next')}
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </ErpTemplate>
    );
}
